import { render, staticRenderFns } from "./DragDropTable.vue?vue&type=template&id=6aa95060&scoped=true"
import script from "./DragDropTable.vue?vue&type=script&setup=true&lang=js"
export * from "./DragDropTable.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DragDropTable.vue?vue&type=style&index=0&id=6aa95060&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa95060",
  null
  
)

export default component.exports